module.exports = __webpack_public_path__ + "img/thumbnail_AsianSmallClawedOtter_m_normal.1d84ad52.png";